import { TDropdownItem, TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { TRESPONSE_GET_MACHINE_AND_LINE_DETAILS } from '@monorepo/types';

export type TAddneedleDetailsFormPayload = {
  needleId: [number];
  quantity: number;
};

const NEEDLE_QTY = {
  input: {
    type: 'INPUT',
    subType: 'number',
    min: 0,
    value: 0,
  },
  metadata: {
    keyName: 'quantity',
    label: 'tm_raise_request.NeedleQuantity',
    isRequired: true,
    dependsOn: {
      keyName: 'needleNumber',
    },
  },
} as const;

export const ADD_NEEDLE_DETAILS_FORM_MODEL = {
  createNeedleDetailsModel: (
    needleDetails?: TRESPONSE_GET_MACHINE_AND_LINE_DETAILS['assignedNeedles'][number],
  ): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: needleDetails
        ? [
            {
              input: {
                type: 'DROPDOWN',
                value: [needleDetails.needleId],
                options: [
                  {
                    value: needleDetails.needleId,
                    displayName: `${needleDetails.needleNumber} / ${needleDetails.needleBrand} / ${needleDetails.needleType}`,
                  },
                ],
              },
              metadata: {
                isRequired: true,
                keyName: 'needleId',
                isDisabled: !!needleDetails,
                label: 'Needle Number / Needle Brand / Needle Type',
              },
            },
            {
              ...NEEDLE_QTY,
              input: { ...NEEDLE_QTY.input, value: needleDetails.quantity, min: needleDetails.quantity },
            },
          ]
        : [
            {
              input: {
                type: 'SEARCH',
                searchOnSearchTextClick: true,
              },
              metadata: {
                keyName: 'needleNumber',
                label: 'machine_action_modal.SearchByNeedleNumber',
                removeFromPayload: true,
                isRequired: true,
              },
            },
            {
              input: { type: 'DROPDOWN_WITH_SEARCH' },
              metadata: {
                keyName: 'needleId',
                label: 'Needle Brand / Needle Type',
                isDisabled: true,
                isRequired: true,
                dependsOn: {
                  keyName: 'needleNumber',
                },
              },
            },
            { ...NEEDLE_QTY },
          ],
      colConfig: 'SINGLE_COL',
    });
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  updateDropdownForKey: (
    key: string,
    liftedFormModel: TLiftedFormModel,
    results: TDropdownItem[],
  ): TLiftedFormModel => {
    return FORM_MODIFIER.updateDropdownForKey(key, liftedFormModel, results);
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },

  generatePayload: (liftedFormModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.generatePayload(liftedFormModel);
  },
};
